import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22.533 8.467a1.593 1.593 0 0 0-2.253 0L16 12.747l-4.28-4.28a1.593 1.593 0 1 0-2.253 2.253l4.28 4.28-4.28 4.28a1.593 1.593 0 0 0 2.252 2.253l4.28-4.28 4.281 4.28a1.593 1.593 0 1 0 2.253-2.253L18.253 15l4.28-4.28a1.593 1.593 0 0 0 0-2.253"
    }, null, -1)
  ]))]))
}
export default { render: render }